<div class="alert alert-success" role="alert">
	<span [innerHTML]="'signup.active_account' | translate"></span>
	<br /><br />
	<span>
		<span class="link" (click)="goToLogin()">Klik hier</span> om in te loggen of je membership te activeren.
		<span class="link" (click)="goToPasswordReset()">Klik hier</span> als je je wachtwoord vergeten bent.
	</span>
</div>